import {
  TableColumns,
  TableFilterTab,
} from '../../../../../../ui-components/lib/table/table.model';
import { ActionList } from '../../../../../common/models/action-list.model';

export const JOB_TITLE_COLUMN_IDENTIFIERS = {
  STATUS: 'status',
};

export const JOB_TITLE_LIST_COLUMNS: TableColumns[] = [
  {
    header: 'job_titles_list_screen_id_table_header',
  },
  {
    header: 'job_titles_list_screen_name_table_header',
    showViewIcon: true,
  },
  {
    header:
      'job_titles_list_screen_assigned_users_table_header_app_group_user_card',
  },
  { header: '' },
];

export const JOB_TITLE_LIST_COLUMNS_SORT: TableColumns[] = [
  {
    header: 'job_titles_list_screen_id_table_header',
    isSortable: true,
    sortKey: 'id][type',
  },
  {
    header: 'job_titles_list_screen_name_table_header',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header:
      'job_titles_list_screen_assigned_users_table_header_app_group_user_card',
    isSortable: true,
    sortKey: 'users_count][type',
  },
  {
    header: 'job_titles_list_screen_status_table_header',
  },
  { header: '' },
];

export const ACTIONS_INDEXES = {
  VIEW: 0,
  EDIT: 1,
  ACTIVATE: 2,
  DEACTIVATE: 3,
  DELETE: 4,
};

export const ACTIONS_MENU_ITEMS: ActionList[] = [
  {
    key: 'view',
    hasIcon: true,
    label: 'view_details_action_item',
    hasDivider: false,
    labelCustomStyle: '',
  },
  {
    key: 'edit',
    hasIcon: true,
    label: 'edit_action_item',
    hasDivider: true,
    labelCustomStyle: '',
  },
  {
    key: 'activate',
    hasIcon: true,
    label: 'activate_action_item',
  },
  {
    key: 'deactivate',
    hasIcon: true,
    label: 'deactivate_action_item',
    labelCustomStyle: 'text-destructive-500!',
  },
  {
    key: 'delete',
    hasIcon: true,
    label: 'delete_action_item',
    labelCustomStyle: 'text-destructive-500!',
  },
];

export const JOB_TITLE_LIST_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'active',
    identifier: 'active',
    label: 'table_filter_tab_active_label',
    active: false,
    iconName: 'active',
  },
  {
    key: 'inactive',
    identifier: 'inactive',
    label: 'table_filter_tab_inactive_label',
    active: false,
    iconName: 'inactive',
  },
];
